var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-carousel",
        {
          attrs: {
            height: "auto",
            cycle: "",
            "hide-delimiter-background": "",
            "show-arrows-on-hover": "",
          },
        },
        _vm._l(_vm.slides, function (item, i) {
          return _c("v-carousel-item", { key: i, attrs: { src: item.src } }, [
            _c("div", { staticClass: "bot-caption d-flex align-center" }, [
              _c("div", [
                _c("h3", { staticClass: "bot-blue" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("h5", [_vm._v(_vm._s(item.subtitle))]),
                _c("div", { staticClass: "bot-text" }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ]),
            ]),
          ])
        }),
        1
      ),
      _c("a", { attrs: { href: "googlechrome://xedapgiakho.com" } }, [
        _vm._v("Open in Chrome"),
      ]),
      _c(
        "a",
        {
          attrs: {
            href: "intent://xedapgiakho.com#Intent;scheme=https;action=android.intent.action.VIEW;end",
          },
        },
        [_vm._v("\n        Mở trong trình duyệt mặc định\n    ")]
      ),
      _c(
        "div",
        { staticClass: "alert-message" },
        [
          !_vm.isAuthen
            ? _c(
                "v-alert",
                { attrs: { type: "success" } },
                [
                  _c("span", [_vm._v("Bạn chưa có tài khoản?")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        href: "/authen/register",
                        outlined: "",
                        title: "Đăng ký",
                      },
                    },
                    [_vm._v("Đăng ký ngay")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/home.vue